// ---------------------------
// Constants and Configuration
// ---------------------------
export const FILE_SIZES = {
  MAX_SIZE: 50 * 1024 * 1024,
} as const;

export const FILE_TYPES = {
  RDF: 'rdf',
  JSON: 'json',
  TTL: 'ttl',
  XML: 'xml',
  XLSX: 'xlsx',
  XLSM: 'xlsm',
} as const;

export const TOAST_MESSAGES = {
  FILE_UPLOAD_FAILED: 'File upload failed:\n',
  VALID_FILE_UPLOADED: 'Valid file uploaded',
  FAILED_TO_READ_FILE: 'Failed to read file',
  PLEASE_UPLOAD_VALID_FILE: 'Please upload a valid file',
  ERROR_UPLOAD_REQUIRED_FILES: 'Error: Please upload all required files.',
  SUCCESS_COMPLETED: 'Success: Operation completed!',
  ERROR_FAILED_TO_RUN: 'Error: Failed to run job. Please try again.',
  READY_FOR_NEW_JOB: 'Ready for a new job!',
  FILE_DOWNLOADED: 'File downloaded!',
  TEMPLATE_DOWNLOADED: 'Template downloaded successfully!',
  ERROR_DOWNLOAD_FAILED: 'Error: Failed to download file. Please try again.',
  ERROR_NO_FILE_AVAILABLE: 'No file available to download.',
  ERROR_EMPTY_FILE: 'Error: Downloaded file is empty or corrupted.',
} as const;

export const API_ENDPOINTS = {
  DOWNLOAD_SESSION_FILE: '/api/files/DownloadSessionFile',
  DOWNLOAD_TEMPLATE: '/api/DockerProcessing/template/download',
  SESSIONS_DOWNLOAD: (sessionId: string, fileName: string) =>
    `/api/dockerprocessing/sessions/${sessionId}/download/${fileName}`,
} as const;

export const VALIDATION_REPORT_FILE = 'validation_report.csv';

export const POLLING = {
  INTERVAL_MS: 5_000,
  MAX_DURATION_MS: 600_000,
} as const;

export const UI_CONSTANTS = {
  FILE_DISPLAY_WIDTH: 500,
  PILL_MAX_WIDTH: 160,
  BUTTON_HEIGHT: 40,
  LARGE_BUTTON_HEIGHT: 50,
  LARGE_BUTTON_WIDTH: 250,
  MEDIUM_BUTTON_WIDTH: 200,
  MEDIUM_BUTTON_HEIGHT: 45,
  INPUT_WIDTH: 360,
  SESSION_LABEL_MIN_WIDTH: 120,
  GRID_GAP: 16,
  SECTION_PADDING: 30,
} as const;
